import * as type from "../../types/API/reportTypes";
import { IAction } from "../userMetadataReducer";

const initialState = {
    data: [],
    loading: false,
    error: null,
    total: 0
};

export const getReportsReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_REPORTS:
            return {
                ...state,
                loading: true,
            };
        case type.GET_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData?.data,
                total: action.payload.responseData?.total
            };
        case type.GET_REPORTS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};
